// import React from 'react';
// import { Line } from 'react-chartjs-2';
// import {
//     Chart as ChartJS,
//     CategoryScale,
//     LinearScale,
//     PointElement,
//     LineElement,
//     Title,
//     Tooltip,
//     Legend,
// } from 'chart.js';

// // Register the required components for Chart.js
// ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

// const CurrentCurveChart = ({ data,name }) => {

//     // const options = {
//     //     responsive: true,
//     //     plugins: {
//     //         legend: {
//     //             position: 'top',
//     //         },
//     //         tooltip: {
//     //             enabled: true,
//     //         },
//     //     },
//     //     scales: {
//     //         x: {
//     //             ticks: {
//     //                 autoSkip: true,
//     //                 maxRotation: 45,
//     //                 minRotation: 45,
//     //             },
//     //         },
//     //         y: {
//     //             title: {
//     //                 display: true,
//     //                 text: 'Current (A)',
//     //             },
//     //         },
//     //     },
//     // };
//     const options = {
//         responsive: true,
//         plugins: {
//             legend: {
//                 position: 'top', // Adjust position if needed
//             },
//             tooltip: {
//                 enabled: true, // Ensure tooltips are enabled
//                 mode: 'nearest', // Show tooltip for the nearest point
//                 intersect: false, // Trigger tooltip even if the mouse is near the line but not directly on it
//                 callbacks: {
//                     label: (context) => {
//                         return `${context.dataset.label}: ${context.raw}`;
//                     },
//                 },
//             },
//         },
//         hover: {
//             mode: 'nearest', // Trigger hover for the nearest point
//             intersect: false, // Allow hover even when the mouse isn't directly intersecting the point
//         },
//         scales: {
//             x: {
//                 ticks: {
//                     autoSkip: true,
//                     maxRotation: 45,
//                     minRotation: 45,
//                 },
//             },
//             y: {
//                 title: {
//                     display: true,
//                     text: name, // Update axis label as needed
//                     font: {
//                         weight: 'bold', // Make the title text bold
//                         size: 16, // You can adjust the font size as well
//                     },
//                 },
//             },
//         },
//     };
    
//     return (
//         <div style={{ width: '100%',maxWidth:"100%", height: 'auto' }}>
//             <Line data={data} options={options} />
//         </div>
//     );
// };

// export default CurrentCurveChart;

//2.with mobile view resposive

import React from 'react';
import { Line } from 'react-chartjs-2';
import "./Tab1Inverter1.css"
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';

// Register the required components for Chart.js
ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

const CurrentCurveChart = ({ data,name }) => {

    const options = {
        responsive: true,
        maintainAspectRatio: false, // Important for mobile
        plugins: {
            legend: {
                position: 'top',
            },
            tooltip: {
                enabled: true,
                mode: 'nearest',
                intersect: false,
                callbacks: {
                    label: (context) => `${context.dataset.label}: ${context.raw}`,
                },
            },
        },
        hover: {
            mode: 'nearest',
            intersect: false,
        },
        scales: {
            x: {
                ticks: {
                    autoSkip: true,
                    maxRotation: 45,
                    minRotation: 45,
                },
            },
            y: {
                title: {
                    display: true,
                    text: name,
                    font: {
                        weight: 'bold',
                        size: 16,
                    },
                },
            },
        },
    };
    
    return (
        <div className="chart-container">
        <Line data={data} options={options} />
    </div>
    
    );
};

export default CurrentCurveChart;